import { useEffect, useRef } from 'react';

const TRUSTPILOT_BOOTSTRAP_SRC =
  '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';

export const TrustpilotWidget = () => {
  const widgetRef = useRef(null);

  useEffect(() => {
    const initWidget = () => {
      if (window.Trustpilot && widgetRef.current) {
        window.Trustpilot.loadFromElement(widgetRef.current, true);
      }
    };

    // Bootstrap script is shared/idempotent - only add it once even if
    // this component mounts more than once.
    let script = document.querySelector(
      `script[src="${TRUSTPILOT_BOOTSTRAP_SRC}"]`
    );
    if (!script) {
      script = document.createElement('script');
      script.src = TRUSTPILOT_BOOTSTRAP_SRC;
      script.async = true;
      script.onload = initWidget;
      document.body.appendChild(script);
    } else {
      initWidget();
    }
  }, []);

  return (
    <div
      ref={widgetRef}
      className="trustpilot-widget"
      data-locale="en-US"
      data-template-id="56278e9abfbbba0bdcd568bc"
      data-businessunit-id="688dec25354b1ad541993d94"
      data-style-height="52px"
      data-style-width="100%"
      data-token="738bf297-eeda-40bf-a8f4-0cc4e47ff720"
      data-testid="trustpilot-widget"
    >
      <a
        href="https://www.trustpilot.com/review/lolcorp.co.uk"
        target="_blank"
        rel="noopener noreferrer"
      >
        Trustpilot
      </a>
    </div>
  );
};
